import { render, staticRenderFns } from "./TextShapeProperties.vue?vue&type=template&id=09867ed0"
import script from "./TextShapeProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextShapeProperties.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports